import Axios from "./axios";

const resource = "video-descriptions";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}